import lz from 'lz-string'
import type { VersionId } from './Versions.js'

// ULICRAFT FORK — share links are GONE, not mirrored.
//
// Upstream's snippet service is a WRITE API (a Cloudflare Worker that stores
// the snippet and mints an id). There is nothing to mirror: it is server-side
// state, and at the party there is no internet to reach it. Reimplementing it
// was explicitly out of scope.
//
// Same-origin dead path so any surviving call site 404s immediately instead of
// hanging on a dead DNS lookup or tripping the vhost's `connect-src 'self'` CSP.
// The share UI is removed separately — a button that silently fails is worse
// than no button.
const API_PREFIX = '/unavailable-offline/snippets'

const ShareCache = new Map<string, string>()

export async function shareSnippet(type: string, version: VersionId, text: string, show_preview: boolean) {
	try {
		const data = lz.compressToBase64(text)
		const body = JSON.stringify({ data, type, version, show_preview })
		let id = ShareCache.get(body)
		if (!id) {
			const snippet = await fetchApi('/', body)
			ShareCache.set(body, snippet.id)
			id = snippet.id as string
		}
		return { id, length: text.length, compressed: data.length, rate: text.length / data.length }
	} catch (e) {
		if (e instanceof Error) {
			e.message = `Error creating share link: ${e.message}`
		}
		throw e
	}
}

export async function getSnippet(id: string) {
	try {
		const snippet = await fetchApi(`/${id}`)
		return {
			...snippet,
			text: lz.decompressFromBase64(snippet.data) ?? '{}',
		}
	} catch (e) {
		if (e instanceof Error) {
			e.message = `Error loading shared content: ${e.message}`
		}
		throw e
	}
}

async function fetchApi(url: string, body?: string) {
	const res = await fetch(API_PREFIX + url, body ? {
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		body,
	} : undefined)
	if (!res.ok) {
		const message = await res.text()
		throw new Error(message)
	}
	return await res.json()
}
